import { render, staticRenderFns } from "./ViewAddedRevenuePage.vue?vue&type=template&id=166518ea"
import script from "./ViewAddedRevenuePage.vue?vue&type=script&lang=js"
export * from "./ViewAddedRevenuePage.vue?vue&type=script&lang=js"
import style0 from "./ViewAddedRevenuePage.vue?vue&type=style&index=0&id=166518ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports